import { HashRouter as Router, Switch, Route, RouteComponentProps } from 'react-router-dom';
import './api/firebase';
import Home from './screens/Home';
import Background from './components/Background';
import Room from './screens/Room';
import AuthFilter from './components/AuthFilter';
import RoomFilter from './components/RoomFilter';
import ThemeProvider from './providers/ThemeProvider';

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <Router>
          <Background />
          <Switch>
            <Route exact path="/" component={Home} />
            <Route
              path="/:roomcode"
              render={(props: RouteComponentProps<any>) => {
                return (
                  <AuthFilter autoSignInIfNotAuthed {...props}>
                    <RoomFilter>
                      <Room />
                    </RoomFilter>
                  </AuthFilter>
                );
              }}
            />
          </Switch>
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
